export class ModulesService{constructor(api){this.api=void 0;this.basePath='/api/modules';this.api=api;}/**
   * Fetch all modules
   */async getModules(){return this.api.get(this.basePath).then(res=>res.data);}/**
   * Fetch a single module by ID
   */async getModule(id){return this.api.get(`${this.basePath}/${id}`).then(res=>res.data);}/**
   * Create a new module
   */async createModule(data){return this.api.post(this.basePath,data).then(res=>res.data);}/**
   * Update an existing module
   */async updateModule(id,data){return this.api.put(`${this.basePath}/${id}`,data).then(res=>res.data);}/**
   * Delete a module
   */async deleteModule(id){await this.api.delete(`${this.basePath}/${id}`);}}